export default function H6({ children }: { children: string }) {
  return (
    <h6 className="inline-block font-secondary bg-gray shadow-layer-gray py-1.5 px-3 mb-3">
      {children}
    </h6>
  );
}
